import { useState } from 'react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav className="fixed top-0 w-full bg-navy bg-opacity-90 backdrop-blur-sm z-50 px-8 py-4 flex justify-between items-center">
      <a href="/" className="text-green font-mono font-bold text-xl">DD</a>

      {/* Desktop menu */}
      <div className="hidden md:flex gap-8">
        {links.map((link, i) => (
          <a key={link.name} href={link.href}
            className="text-slate hover:text-green transition-all font-mono text-sm">
            <span className="text-green">0{i + 1}. </span>{link.name}
          </a>
        ))}
      </div>

      {/* Mobile hamburger */}
      <button className="md:hidden text-green text-2xl"
        onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✕' : '☰'}
      </button>

      {/* Mobile menu */}
      {isOpen && (
        <div className="absolute top-16 left-0 w-full bg-navy-light flex flex-col items-center gap-6 py-8 md:hidden">
          {links.map((link, i) => (
            <a key={link.name} href={link.href}
              onClick={() => setIsOpen(false)}
              className="text-slate hover:text-green transition-all font-mono">
              <span className="text-green">0{i + 1}. </span>{link.name}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navbar;